import { render, staticRenderFns } from "./ExhibitionWork.vue?vue&type=template&id=445bee00&"
import script from "./ExhibitionWork.vue?vue&type=script&lang=js&"
export * from "./ExhibitionWork.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports